import { Outlet, useOutletContext } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import FoldersSettings from 'modules/documents/components/Settings/Folders'
import { SPACES } from 'modules/documents/lib/constants'

interface OutletContext {
  canManageEmployeesFolders: boolean
}

const EmployeesFolderSettingPage = () => {
  const space = SPACES.EMPLOYEE_MY_DOCUMENTS
  const folderVariables = { space, rootFolders: true }
  const { company } = useCurrentSession()
  const { navigation } = useNavigation()
  const { canManageEmployeesFolders } = useOutletContext<OutletContext>()

  return (
    <>
      <Outlet
        context={{
          parentRoute: navigation.settings.folders.employees.fullPath(),
          space,
          companyId: company.id,
        }}
      />

      <FoldersSettings
        space={space}
        folderVariables={folderVariables}
        canManage={canManageEmployeesFolders}
        newFolderRoute={navigation.settings.folders.employees.new.fullPath()}
      />
    </>
  )
}

export default EmployeesFolderSettingPage
